export default __webpack_public_path__ + "static/media/iUSD+.819ff48f.svg";